<div>
	<freud-scroll-panel [style]="notifications.length > 0 ? {height: notifications.length > 4 ? '570px' : '370px', width: '366px'} : {}">
		<ng-container *ngFor="let notification of notifications">
			<article (click)="interactWithNotification(notification)" class="notifications-row zk-flex zk-gap-4 zk-mb-4">
				<div class="icon-image">
					<img [src]="notification.image" alt="" width="40" height="40" />
				</div>
				<div class="zk-flex zk-flex-col zk-gap-1">
					<p data-testid="notification-title" freud-typography fontType="h5Semibold1-2">
						{{ notification.title }}
					</p>
					<p data-testid="notification-description" class="notification-description" freud-typography fontType="h6Regular1-2">
						{{ notification.description }}
					</p>
				</div>
				<div class="zk-flex zk-flex-col zk-gap-4">
					<div class="zk-flex zk-gap-2 zk-justify-end zk-items-center">
						<circle *ngIf="!notification.seen"></circle>
						<p data-testid="notification-date" freud-typography fontType="h6Regular1-5">
							{{ formatNotificationDate(notification.createdAt) }}
						</p>
					</div>
					
					<div (click)="$event.stopPropagation()" class="zk-flex zk-justify-end">
						<span class="freud-icon freud-icon-dots freud-icon-md dots-button"
							(click)="setNotificationToBeHidden(notification.id)"
						></span>
						<div class="hide-notification-menu">
							<freud-menu #hideNotification *ngIf="getNotificationToBeHidden() === notification.id" [items]="menuActions"></freud-menu>
						</div>
					</div>	
				</div>	
			</article>
		</ng-container>
	</freud-scroll-panel>
</div>